module.exports = __webpack_public_path__ + "media/metronic/_theme/media/company-logos/logo_client_color-9f2db3ad16516000c3b27cb136622b52.png";